import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import { ZHSMRegularKek } from '../types'

const ZHSMRegularKekObj = z.object({
  total_count: z.number(),
  list: z.array(ZHSMRegularKek)
})

const ZApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: z.optional(ZHSMRegularKekObj)
})

export type HSMRegularKekObj = z.infer<typeof ZHSMRegularKekObj>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function getHSMRegularKekList (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string,
  onSuccess: (hsmRegularKekObj: HSMRegularKekObj, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  let field = sortfield
  if (field === 'created At') {
    field = 'createdAt'
  } else if (field === 'created By') {
    field = 'createdBy'
  }
  const url = `/app-config-service/api/v1/crypto/hsm-keks-db?page=${page}&size=${size}&sort=${field},${sortdir}&input=${input}`
  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore next
      if (parseResponse.success) {
        if (parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        } else {
          onFailure({ totalCount: 0, list: [] }, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        // istanbul ignore next
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
